<template>
    <div>
        <div ref="text" class="stories-text" :class="{ 'stories-text-short': textShort }">{{ text }}</div>
        <div v-if="showLink" class="stories-more">
            <span v-if="textShort" @click="showFull" class="stories-more-text">
                {{ $t('feed.readCompletely') }}
            </span>
            <span v-else @click="showCut" class="stories-more-text">
                {{ $t('feed.hide') }}
            </span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'StoryText',
    props: {
        text: {
            type: String,
            required: true
        },
        index: {
            type: Number,
            required: false
        }
    },
    data() {
        return {
            initialHeight: 0,
            maxHeight: 240,
            showLink: false,
            textShort: false,
            tabsUpdatedLocal: true
        }
    },
    computed: {
        ...mapGetters({
            tabsUpdated: 'stories/fetchTabsUpdated'
        })
    },
    mounted() {
        this.checkText();
    },
    watch: {
        tabsUpdated() {
            this.checkText();
        }
    },
    methods: {
        checkText() {
            this.initialHeight = 0;
            this.showLink = false;
            this.textShort = false;
            setTimeout(() => {
                this.initialHeight = this.$refs.text.offsetHeight;
                if (this.initialHeight > this.maxHeight) {
                    this.showLink = true;
                    this.textShort = true;
                }
            }, 100);
        },
        showFull() {
            this.textShort = false;
        },
        showCut() {
            this.textShort = true;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/layout/_stories-block';
</style>
